import { render, staticRenderFns } from "./ModuleSelfDiagnosisStatusBadge.vue?vue&type=template&id=2aced019&scoped=true&"
import script from "./ModuleSelfDiagnosisStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ModuleSelfDiagnosisStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSelfDiagnosisStatusBadge.vue?vue&type=style&index=0&id=2aced019&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aced019",
  null
  
)

export default component.exports